import { useMemo } from 'react'

import { matchFilterNumber, sortArrayBy } from '@domain-group/javascript-utils'

import { useWatchEntityUpdates } from '@domain-group/react-hooks'

import useSelector from '@hooks/useSelector'

const watchEntityKeys = ['invoiceAttachments']

export type InvoiceAttachmentsFilters = {
  campaign_id?: number,
  invoice_id?: number,
}

interface UseInvoiceAttachmentsOptions {
  filters?: InvoiceAttachmentsFilters,
}

function useInvoiceAttachments(options: UseInvoiceAttachmentsOptions = {}) {
  const { filters = {} } = options
  const {
    invoice_id: filterInvoiceId,
  } = filters

  const {
    updatedEntities: { invoiceAttachments: invoiceAttachmentsUpdatedAt },
  } = useWatchEntityUpdates(watchEntityKeys)

  const { invoiceAttachments } = useSelector(reduxState => reduxState.entities)

  const filteredInvoiceAttachments = useMemo(() => {
    const filtered = Object.values(invoiceAttachments).filter((attachment) => {
      const { invoice_id } = attachment

      const matchInvoiceId = matchFilterNumber(invoice_id, filterInvoiceId)

      return matchInvoiceId
    })

    return sortArrayBy(filtered, 'asc', 'id')
  }, [invoiceAttachmentsUpdatedAt, JSON.stringify(filters)])

  const filteredInvoiceAttachmentsCount = filteredInvoiceAttachments.length
  const hasFilteredInvoiceAttachments = !!filteredInvoiceAttachmentsCount

  return {
    callbacks: {},
    filteredInvoiceAttachments,
    filteredInvoiceAttachmentsCount,
    hasFilteredInvoiceAttachments,
  }
}

export default useInvoiceAttachments
